import * as React from 'react';

import './styles.scss';
import Icon from '../Icon';

export interface ILoadingAppProps {}
interface IState {}
/**
 * Covers all while app should be completely locked. For example while loading initial or critical data.
 */
class LoadingApp extends React.Component<ILoadingAppProps, IState> {
    static displayName: string = 'LoadingApp';
    render () {
        return (
            <div className="loading-app">
                <Icon width={60} height={60} kind="loading"/>
            </div>
        );
    }
}

export default LoadingApp;
